import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { VesignDataService } from '../service/vesign-data.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-partner-cons-completeddocs',
  templateUrl: './partner-cons-completeddocs.component.html',
  styleUrls: ['./partner-cons-completeddocs.component.css']
})
export class PartnerConsCompleteddocsComponent implements OnInit,AfterViewInit {

  DocId: number = 0;
  PackageList = [];
  SupportPackageList=[];
  GciID: number = 0;
  IsemailWrapPopupOpen: boolean = false;
  IsView_Supporting_docsPopupOpen: boolean=false;
  emailWrapStyle = [];
  viewsupportDocStyle=[];
  EmailLogId: number = 0;
  pinID: number = 0;
  EmailId: string = "";
  VendorConsDocList = [];
  VendorConsDocDropList = [];
  TaskId: number = 0;
  DocType: string = "";
  OnboardingContactPopup: string = '';
  IsOnboardingContactPopup: boolean = false;
  AdditionalPopupStyle: string = "none";
  IsAdditionalDocsPopupOpen: boolean = false;
  paramsObject;
  constructor(private location: Location, private route: ActivatedRoute, public router:Router,public sanitizer: DomSanitizer,private dataService: VesignDataService<any>, private spinner: NgxSpinnerService
  ) { }
  OnboardingContactWrapStyle = [];
  SearchBy = {
    SearchBySpecificColumns: '',
    Vendor_code: '',
    taskId: null,
  }

  PinActiverecords: any = {
    pinID: 0,
    task_id: '',
    envMstrID: '',
    EmailLogId: '',
    IsActive: true,
    Doc_Type: ''
  }
  Search = {
    vendorCode: "",
    taskId: null,
    gcId: null,
    search: null
  }
  ngOnInit(): void {
//debugger
    this.spinner.show();
    this.dataService.setVendorName(sessionStorage.getItem('UserName')!=null ? sessionStorage.getItem('UserName').toString() : "");
    this.route.queryParamMap.subscribe((params) => {
      this.paramsObject = { ...params.keys, ...params }
      this.SearchBy.Vendor_code = sessionStorage.getItem("VendorCode");

      if (this.paramsObject.params.taskId != undefined) {
        this.SearchBy.taskId = this.paramsObject.params.taskId;
        this.SearchBy.SearchBySpecificColumns=this.paramsObject.params.candidateName;
        this.setQueryParams();
      }
      //get take action page count
     // if (this.paramsObject.params.PackageCountInTakeAction != undefined) {
        this.Search.vendorCode = sessionStorage.getItem("VendorCode");
        this.getTakeActionPendingDocsCount(this.Search);
       // this.setQueryParams();
    //  }
      //this.location.replaceState('/viewcompleteddocs');
      this.GetVendorConsultantCompletePackages(this.SearchBy);
      this.GetViewCompletedDocsCount(this.SearchBy);
    });
    this.spinner.hide();
  }
  setQueryParams(){
    const qParams: Params = {};
    this.router.navigate([], {
        relativeTo: this.route,
        queryParams: qParams,
        queryParamsHandling: ''
    });
}
getTakeActionPendingDocsCount(search: any) {
  this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/GetEsignConsultantPendingPackagesCount", search)
    .subscribe(
      (response: any) => {
        this.dataService.setTakeActionCount(response);
        // console.log(response);
      },
      error => {
        console.log(error);
      });
}
  SearchClick(value: string = '') {
   // debugger
    this.SearchBy.taskId = null;
    value != '' ? this.SearchBy.SearchBySpecificColumns = "" : '';
    this.SearchBy.Vendor_code = sessionStorage.getItem("VendorCode");
    this.GetVendorConsultantCompletePackages(this.SearchBy);
    this.GetViewCompletedDocsCount(this.SearchBy);
  }
  // SearchClick()
  // {
  //   this.spinner.show();
  //   this.SearchBy.Vendor_Code='CO00040';
  //   console.log(this.SearchBy)   

  //     debugger;
  //   this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsDocsbySearch", this.SearchBy)
  //     .subscribe(        
  //       (response: any) => {          
  //         this.PackageList = response;        
  //         console.log(response);
  //         this.GetViewCompletedDocsCount();
  //       },
  //       error => {
  //         console.log(error);

  //       });

  // }

  base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  ViewUploadedFile(FileContent, UploadedFileName, IsDownload) {
    let mimeType;
    const selectedFileType = UploadedFileName.replace('.aspx', '.pdf').split('.').pop();

    const FileType = [
      // { key: "jpg", value: 'image/jpg', IsDownload: "0" },
      // { key: "jpeg", value: 'image/jpeg', IsDownload: "0" },
      // { key: "png", value: 'image/png', IsDownload: "0" },
      { key: "pdf", value: 'application/pdf', IsDownload: "0" },
      // { key: "xlsx", value: 'application/vnd.ms-excel', IsDownload: "1" },
      // { key: "xls", value: 'application/vnd.ms-excel', IsDownload: "1" },
      // { key: "doc", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      // { key: "docx", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      // { key: "msg", value: 'application/vnd.ms-outlook', IsDownload: "1" }
    ];

    mimeType = FileType.filter((value) => value.key == selectedFileType);

    if (mimeType.length > 0) {
      this.spinner.show();
      var blob = this.base64ToBlob(FileContent, mimeType[0].value);
      if (IsDownload == "1") {
        var link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = UploadedFileName.replace('.aspx', '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.spinner.hide();
      }
      else {
        var url = window.URL.createObjectURL(blob);
        window.open(url);
        this.spinner.hide();
      }
    }
  }
  DownloadFile(filename: string, Doc: any, isDownloadorView: string) {
    if (Doc != null) {
      this.ViewUploadedFile(Doc, filename, isDownloadorView)
    }
  }

  emailWrapPopup(emailLogId) {
    this.IsemailWrapPopupOpen = !this.IsemailWrapPopupOpen;
    if (this.IsemailWrapPopupOpen) { this.emailWrapStyle[emailLogId] = "custom_modal active" }
    else { this.emailWrapStyle[emailLogId] = "custom_modal" }
  }


  OpenSupportDocPopup(task_Id)
  {
    //debugger;
    //this.TaskId=task_Id;
    this.IsAdditionalDocsPopupOpen = !this.IsAdditionalDocsPopupOpen;
    if (this.IsAdditionalDocsPopupOpen) {
      this.AdditionalPopupStyle = "block"
    }
    else {
      this.AdditionalPopupStyle = "none"
    }
    this.SupportPackageList=[];
    if(task_Id!=''){
    this.spinner.show();
    this.dataService.Get(environment.eSignApiUrl + "/api/VendorEsign/GetVendorAllSupportingDocList?TaskId="+task_Id,null)
      .subscribe(        
        (response: any) => {   
     //debugger;
        // console.log(response);
          this.SupportPackageList = response;      
          this.spinner.hide();
        },
        error => {
          console.log(error);
         
        });
      }
  }



  ViewVendorConCompletedDocumentList(taskId, EmailLogId, EmailId) {
    this.EmailLogId = EmailLogId;
    this.EmailId = EmailId;
    if (this.VendorConsDocDropList.length != 0) {
      this.VendorConsDocDropList = [];
      this.DocType = '';

    }
    else {
      this.spinner.show();
      this.TaskId = taskId;
      this.VendorConsDocList = [];
      this.VendorConsDocDropList = [];
      this.DocType = '';

      this.dataService.Get(environment.eSignApiUrl + "/api/VendorEsign/ViewVendorCompletedDocsList?TaskID=" + taskId + "&EmailLogId=" + EmailLogId, null)
        .subscribe(
          (response: any) => {
            this.VendorConsDocList = response;
            this.VendorConsDocList.forEach((value, index) => {
              if (this.DocType != value.doc_category) {
                {
                  this.VendorConsDocDropList.push({ SNO: value.sno, DocCategory: value.doc_category, DocList: [] });
                }
                this.DocType = value.doc_category
              }
              let latestIndex: any = this.VendorConsDocDropList.length - 1;
              this.VendorConsDocDropList[latestIndex].DocList.push({ DocID: value.sno, DocCategory: value.doc_category, FilePath: value.filePath, IsEditable: (value.filePath.split('.').pop() == "aspx" || value.filePath.split('.').pop() == "asp") ? true : false, DocName: value.actual_Form_Name, TaskID: value.task_id, Signed: value.signed, FileContent: value.uploadedFileData, UploadedFileName: value.uploadedFileName, DocuSignStatus: value.docuSign_Status });

            });
            this.spinner.hide();
          },
          error => {
            console.log(error);
            this.spinner.hide();
          });
      //console.log(this.VendorConsDocDropList);
    }
  }

  UnPinVendorConsselectedDocs(taskId, envMstrID, EmailLogId, pinID,doc_type) {
    this.PinActiverecords.task_id = taskId;
    this.PinActiverecords.envMstrID = envMstrID;
    this.PinActiverecords.EmailLogId = EmailLogId;
    this.PinActiverecords.pinID = pinID;
    this.PinActiverecords.Doc_Type=doc_type;
    //debugger;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/InsPinVendorCompletedocsActiveRecords", this.PinActiverecords)
      .subscribe(
        res => {

          //console.log(res);
          //this.notify.successMsg("Record Pined Successfully.");  
          this.GetVendorConsultantCompletePackages(this.SearchBy);
        },
        error => {
          console.log(error);
          //this.spinner.hide();
        });
  }

  PinVendorConsselectedDocs(taskId, envMstrID, EmailLogId, Doc_type) {
    this.PinActiverecords.task_id = taskId;
    this.PinActiverecords.envMstrID = envMstrID;
    this.PinActiverecords.EmailLogId = EmailLogId;
    this.PinActiverecords.Doc_Type = Doc_type;
    //this.pinID=pinID;
    //debugger;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/InsPinVendorCompletedocsActiveRecords", this.PinActiverecords)
      .subscribe(
        res => {

         // console.log(res);
          //this.notify.successMsg("Record Pined Successfully.");  
          this.GetVendorConsultantCompletePackages(this.SearchBy);
        },
        error => {
          console.log(error);
          //this.spinner.hide();
        });
  }
  ngAfterViewInit(){
  this.spinner.show();
    setTimeout(() => 
    this.autoExpand(),4000
   );
  }
  autoExpand(){
    //debugger
    this.PackageList.forEach((value,index)=>{
      if(index==0){
        let element:HTMLElement=document.getElementById(value.emailLogId) as HTMLElement
        element.click();
      }
    })
    this.spinner.hide();
  }
  GetVendorConsultantCompletePackages(SearchBy: any) {

    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantCompletePackages", SearchBy)
      .subscribe(
        (response: any) => {
        //  debugger;
         // console.log(response);
          this.PackageList = response;
         
        },
        error => {
          console.log(error);

        });
  }

  GetViewCompletedDocsCount(SearchBy: any) {

    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantCompleteDocsCount", SearchBy)
      .subscribe((response: any) => {
        //debugger;
        this.dataService.setVendorViewCompeletedDocsCount(response);

      });



  }


}
